module.exports = __webpack_public_path__ + "static/media/pemilu1.f951f52d.JPG";